









import appSdk from './sdk/sdk';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {State, Getter, Action, Mutation} from 'vuex-class';
import HeaderComponent from './components/Header/Header.vue';

@Component({
  components: {
    HeaderComponent,
  },
})
export default class App extends Vue {
  @Getter('deviceName')
  private deviceName!: any;
  @Action('getDeviceName')
  private getDeviceName!: any;

  private isInApp() {
    return navigator.userAgent.toLowerCase().indexOf('nio-lifestyle') !== -1;
  }

  private created() {
    document.title = '一键加电全介绍';
    if (this.isInApp()) {
      appSdk.init();
    }
  }

  private mounted() {
    this.getDeviceNameFun();
  }

  private getDeviceNameFun() {
    this.getDeviceName();
  }
}
